import React, {Component} from 'react';
import PropTypes from "prop-types";
import {AddFavouritesApp} from "../../apps/AddFavouritesApp";
import translate from "../../services/translation";
import NumberFormat from "react-number-format";
import LinesEllipsis from "react-lines-ellipsis";
import LabelPopup from "./LabelPopup";


export default class TeaserItem extends Component {

    static propTypes = {
        favouriteItem: PropTypes.object,
        onRemove: PropTypes.func,
        type: PropTypes.string,
        favouriteLink: PropTypes.string,
        labelPopupShow: PropTypes.object
    };

    constructor(props) {
        super(props);

        this.state = {
            labelPopupShow: {},
        };
    }

    handleMouseEnter = (label) => {
        this.setState((prevState) => ({
            labelPopupShow: {
                ...prevState.labelPopupShow,
                [label]: true,
            },
        }));
    };

    handleMouseLeave = (label) => {
        // Set the corresponding label's popup to false
        this.setState((prevState) => ({
            labelPopupShow: {
                ...prevState.labelPopupShow,
                [label]: false,
            },
        }));
    };

    render() {
        const {favouriteItem, onRemove, type, favouriteLink} = this.props;

        return (
            <div className={'favouriteItemWrapper teaserItem col-12 col-md-6 col-lg-4 col-xl-3' + (type === 'itinerary' ? ' itineraryTeaserItem' : '')}>
                <div className="favouriteItemContainer teaserItemContainer">
                    <div className="teaserItemImageWrapper">
                        <a href={favouriteItem.detailPageUrl}>
                            {favouriteItem.travelarea &&
                                <div className="favouriteItemTravelarea teaserItemTravelarea">
                                    {favouriteItem.travelarea}
                                </div>
                            }
                            <div className="favouriteItemImage teaserItemImage">
                                <img alt={favouriteItem.title} src={ type === 'excursion' ? favouriteItem.teaserImageUrl : favouriteItem.mapUrl} onError={(event) => event.target.style.display = 'none'} />
                             </div>
                        </a>
                    </div>

                    <div className="teaserItemTextWrapper">
                        {favouriteItem.label.length > 0 &&
                            <LabelPopup labels={favouriteItem.label} />
                        }

                        {type === 'excursion' &&
                            <AddFavouritesApp excursionUid={favouriteItem.uid} favouriteType={'excursion'}
                                              favouriteLink={favouriteLink}/>}
                        {type === 'itinerary' &&  <AddFavouritesApp itineraryUid={favouriteItem.uid} favouriteType={'itinerary'} favouriteLink={favouriteLink}/>}

                        {onRemove &&
                            <div className="favouriteItemRemove">
                                <button onClick={() => onRemove(favouriteItem.uid)}>
                                    <span className="removeButtonText hiddenText">{translate('favourite.close')}</span>
                                    <span className="removeButtonIcon"/>
                                </button>
                            </div>
                        }

                        <a href={favouriteItem.detailPageUrl}>
                            {favouriteItem.category &&
                                <div className="favoriteItemCategory">
                                    {favouriteItem.category}
                                </div>
                            }

                            <div className="favouriteItemHeadline teaserItemHeadline">
                                <h2>{favouriteItem.title}</h2>
                            </div>

                            {(favouriteItem.description || favouriteItem.teaser) &&
                                <div className="favouriteItemText teaserItemText">
                                    <LinesEllipsis
                                        text={type === 'excursion' ? favouriteItem.description : favouriteItem.teaser}
                                        maxLine='3'
                                        ellipsis='...'
                                        trimRight
                                        basedOn='letters'
                                    />
                                </div>
                            }

                            <div className="favouriteItemInfo">
                                {type === 'excursion' && favouriteItem.duration !== 0 &&
                                    <div className="favouriteItemDuration">
                                        <span>
                                            {favouriteItem.duration}&nbsp;{favouriteItem.duration === 1 ? translate('excursion_item.hours').slice(0, -1) : translate('excursion_item.hours')}
                                        </span>
                                    </div>
                                }
                                {type === 'excursion' && favouriteItem.weekdays.length > 0 &&
                                    <div className="favouriteItemWeekdays">
                                        {favouriteItem.weekdays.map(weekday => <span key={crypto.randomUUID()} className="favouriteItemWeekday">{weekday}</span>)}
                                    </div>
                                }
                                {type === 'itinerary' && favouriteItem.distance !== null &&
                                     <div className="favouriteItemDistance">
                                        <span>{translate('favourite.distance')} {favouriteItem.distance} km</span>
                                    </div>
                                }
                                {favouriteItem.price !== 0 ?
                                    <div className="favouriteItemPrice">
                                        <span className="fromPriceText">{translate('itinerary_item.from')}</span>
                                        <span className="fromPrice"><NumberFormat prefix={'Fr. '} value={favouriteItem.price} displayType='text' thousandSeparator={"'"} suffix={'.-'} /></span>
                                        <span className="fromPriceInfo">
                                            {type === 'excursion' && favouriteItem.priceLabel ? favouriteItem.priceLabel : translate('itinerary_item.price_per_person')}
                                        </span>
                                    </div>
                                    :
                                    <span className="fromPriceInfo">{translate('itinerary_item.price_on_request')}</span>
                                }
                                {type === 'excursion' && favouriteItem.ltrKey &&
                                    <div className="favoriteItemLtr">
                                        {favouriteItem.ltrKey}
                                    </div>
                                }
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Favourites/TeaserItem.js